import { ArrowIcon, SvgIcon } from "@cmsgov/ds-medicare-gov";
import { useMctFlags } from "../../../helpers/flag-hooks/useMctFlags";

export type MctArrowDirection = "up" | "down" | "left" | "right";

type MctArrowIconProps = {
  className?: string;
  direction?: MctArrowDirection;
};

const rotationByDirection: Record<MctArrowDirection, string> = {
  right: "rotate(0deg)",
  down: "rotate(90deg)",
  left: "rotate(180deg)",
  up: "rotate(-90deg)",
};

export const BackArrowIcon = ({
  className,
  direction = "left",
}: MctArrowIconProps) => {
  const { tmpFeEnableMgovReskin } = useMctFlags();

  if (!tmpFeEnableMgovReskin) {
    return <ArrowIcon direction={direction} className={className} />;
  }

  return (
    <SvgIcon
      className={className}
      height="16px"
      title="Arrow"
      viewBox="0 0 16 15"
      width="16px"
      style={{
        transform: rotationByDirection[direction],
        transformOrigin: "center",
        height: "1rem",
        width: "1rem",
      }}
    >
      <path
        d="M8.4587 15L6.85714 13.4227L11.654 8.65206H0V6.34794H11.654L6.85714 1.58505L8.4587 0L16 7.5L8.4587 15Z"
        fill="currentColor"
      />
    </SvgIcon>
  );
};
